import { useCallback, useEffect, useState } from 'react';
import { getAPI } from '../../services/api.service';
import { useDebounce } from '../../Utils/debounce';

export function useFetchUsers() {
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(1);
  const [limit, setLimit] = useState(10);
  const [role, setRole] = useState('All');
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 300);

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getAPI<{ data: { users: any[],total:number,limit:number } }>(`auth/users`, {
        page,
        limit,
        role,
        search: debouncedSearch
      });
      if (response.status === 200) {
        setUsers(response.data?.data?.users ?? []);
        setTotalRecords(response.data?.data?.total ?? 1);
      } else {
        setError(response.error as string);
      }
    } catch (err) {
      setError('Failed to fetch users.');
    } finally {
      setLoading(false);
    }
  }, [page, role, debouncedSearch]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  return { users, loading, error, page, totalRecords, limit, setPage, role, setRole, search, setSearch, refetch: fetchUsers };
}